<!-- Global site tag (gtag.js) - Google Ads: 344870238 -->
window.dataLayer = window.dataLayer || []

function gtag () {dataLayer.push(arguments)}

gtag('js', new Date())

gtag('config', 'AW-344870238')
